import { ASSET_BASE_URL } from './api';

const isAbsoluteUrl = (url) => /^https?:\/\//i.test(url);

const buildImageUrl = (imageUrl) => {
  if (!imageUrl) {
    return null;
  }

  if (isAbsoluteUrl(imageUrl)) {
    return imageUrl;
  }

  const normalizedPath = imageUrl.startsWith('/') ? imageUrl : `/${imageUrl}`;
  return `${ASSET_BASE_URL}${normalizedPath}`;
};

export default buildImageUrl;
